"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgTaskCardEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M94.524 54.993l-7.305-4.031M87 61.834V27H35v34.828M35 50.7l-7.55 4.293",
    stroke: props.color || "#133251",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.994 83.24L94 56.183V92H28V56.128L46.11 71.14h.001l14.571 12.083.012.01.013.01.029.022.64.497.618-.523z",
    stroke: props.color || "#133251",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.422 63.533c2.46 0 5.904-.369 9.225-1.968l-.615-1.886a19.71 19.71 0 01-8.569 1.886c-9.43 0-12.546-6.929-12.546-12.095 0-6.806 5.371-12.218 12.177-12.218 5.986 0 10.947 4.018 10.947 10.21 0 4.878-2.706 7.83-4.633 7.83-1.353 0-1.476-1.312-1.517-1.886v-.328c.082-.82.78-5.37 1.927-10.209h-2.132l-.533 2.624c-.574-1.68-2.009-3.157-4.51-3.157-4.264 0-7.175 3.936-7.175 8.323 0 3.65 2.214 6.601 5.74 6.601 3.116 0 4.756-2.337 5.125-2.91.123 1.64 1.312 2.746 2.993 2.746 3.24 0 6.683-3.977 6.683-9.676 0-7.339-5.986-12.136-12.956-12.136-7.995 0-14.227 6.232-14.227 14.145 0 8.323 6.11 14.104 14.596 14.104zm-1.763-8.487c-1.927 0-3.813-1.517-3.813-4.469 0-3.075 2.132-6.027 5.002-6.027 1.763 0 3.526 1.107 3.526 3.977 0 3.321-1.804 6.52-4.715 6.52z",
    fill: props.color || "#133251"
  }));
}

var _default = SvgTaskCardEmail;
exports["default"] = _default;